export default __webpack_public_path__ + "static/media/dongho.3c245642.jpg";